import React from 'react';
import { RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import CookieBanner from '@component/CookieBanner';
import { useState } from 'react/cjs/react.production.min';
import i18n from 'i18next';
import { useEffect } from 'react/cjs/react.production.min';

const CookieBannerComponent = (props) => {
  const [checkBanner, setCheckBanner] = useState(true);
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const isDocument = typeof document !== 'undefined';

  const setCookie = () => {
    const cookieDate = new Date();
    cookieDate.setFullYear(cookieDate.getFullYear() + 1);
    document.cookie = `rotary_cookie_complaince=1; expires=${cookieDate.toUTCString()}`;
    setShowCookieBanner(false);
  };

  useEffect(() => {
    if (document?.cookie?.includes('rotary_cookie_complaince')) {
      setShowCookieBanner(false);
    }
    setCheckBanner(false);
  }, [isDocument]);

  return (
    <>
      {showCookieBanner && !checkBanner && (
        <CookieBanner
          CookieBannerText={<RichText field={props.fields?.text} />}
          closeButton={i18n.t('button/close') || 'Close'}
          handleClick={() => setCookie()}
        />
      )}
    </>
  );
};
export default withSitecoreContext()(CookieBannerComponent);
